export const LOGIN_LOADING = 'LOGIN_LOADING';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FEATURE = 'LOGIN_FEATURE';
export const LOGIN_RESET = 'LOGIN_RESET';
